import { Notebook } from '@phosphor-icons/react/dist/ssr/Notebook';
import { GearSix } from '@phosphor-icons/react/dist/ssr/GearSix';
import { Vault } from '@phosphor-icons/react/dist/ssr/Vault';
import { Clock } from '@phosphor-icons/react/dist/ssr/Clock';
import { ChartBar } from '@phosphor-icons/react/dist/ssr/ChartBar';
import { Coins } from '@phosphor-icons/react/dist/ssr/Coins';
import { Trophy } from '@phosphor-icons/react/dist/ssr/Trophy';
import { UsersThree } from '@phosphor-icons/react/dist/ssr/UsersThree';
import { ChatCircleDots } from '@phosphor-icons/react/dist/ssr/ChatCircleDots';
import { Buildings } from '@phosphor-icons/react/dist/ssr/Buildings';
import { Wrench } from '@phosphor-icons/react/dist/ssr/Wrench';
import { Bug } from '@phosphor-icons/react/dist/ssr/Bug';
import { BookOpenText } from '@phosphor-icons/react/dist/ssr/BookOpenText';
import { Footprints } from '@phosphor-icons/react/dist/ssr/Footprints';
import { Scroll } from '@phosphor-icons/react/dist/ssr/Scroll';
import { ShootingStar } from '@phosphor-icons/react/dist/ssr/ShootingStar';
import { Crown } from '@phosphor-icons/react/dist/ssr/Crown';
import { Handshake } from '@phosphor-icons/react/dist/ssr/Handshake';
import { HandCoins } from '@phosphor-icons/react/dist/ssr/HandCoins';
import { UserList } from '@phosphor-icons/react/dist/ssr/UserList';
import type { AppView } from '@aegislab/shared';

/**
 * 뷰 → 아이콘 단일 소스.
 *
 * 데스크톱 `CarouselDock` 과 모바일 `QuickNav` 가 함께 소비한다. 목록(`shared/config/appNav`)만
 * 통일하고 아이콘 맵을 이원화해 두면, 새로 노출되는 뷰가 한쪽에서만 generic 폴백으로 뜬다.
 *
 * `default:` 가 있어 `case` 누락을 tsc 가 못 잡는다 —
 * `__tests__/appViewIcon.test.tsx` 의 폴백 감지 단언이 그 자리를 지킨다.
 */
export function getAppViewIcon(view: AppView, size = 24): React.ReactNode {
  switch (view) {
    case 'today':
      return <Footprints size={size} weight="duotone" />;
    // 개발 퀘스트도 퀘스트 창의 한 인스턴스라 같은 아이콘을 쓴다(헤더 세그먼트도 QuestIcon).
    case 'quests':
    case 'world-quests':
    case 'dev-quests':
    case 'leaderboard':
      return <Trophy size={size} weight="duotone" />;
    case 'attendance':
      return <Clock size={size} weight="duotone" />;
    case 'work-log':
      return <Notebook size={size} weight="duotone" />;
    case 'chat':
      return <ChatCircleDots size={size} weight="duotone" />;
    case 'team-settings':
      return <GearSix size={size} weight="duotone" />;
    case 'admin-attendance':
      return <UsersThree size={size} weight="duotone" />;
    case 'hr-management':
      return <Buildings size={size} weight="duotone" />;
    case 'finance':
      return <Vault size={size} weight="duotone" />;
    case 'bug-reports':
      return <Bug size={size} weight="duotone" />;
    case 'wiki':
      return <BookOpenText size={size} weight="duotone" />;
    case 'scenarios':
      return <Scroll size={size} weight="duotone" />;
    case 'advertiser-console':
      return <ShootingStar size={size} weight="duotone" />;
    case 'creator-relations':
      return <Handshake size={size} weight="duotone" />;
    // 사람 목록을 받아 가는 창 — 크리에이터 관계와 같은 사람 가족(people) 톤.
    case 'creator-lists':
      return <UserList size={size} weight="duotone" />;
    case 'usage-dashboard':
      return <ChartBar size={size} weight="duotone" />;
    case 'campaign-bonus':
      return <Coins size={size} weight="duotone" />;
    case 'ceo-console':
      return <Crown size={size} weight="duotone" />;
    // 재무(Vault, 보관)와 가른다 — 정산 실행은 쥔 돈을 밖으로 내보내는 일이다.
    case 'campaign-settlement':
    case 'domestic-settlement':
      return <HandCoins size={size} weight="duotone" />;
    // 전용 아이콘 미지정 뷰 — 폴백(Wrench)
    // lounge는 내비 미노출(NAV_ITEMS 제외) — switch-exhaustiveness 방어용
    case 'system-admin':
    case 'lounge':
    default:
      return <Wrench size={size} weight="duotone" />;
  }
}
